module.exports = __webpack_public_path__ + "img/title-shiba111.a41d4a94.png";